import React, { useRef } from 'react';
import styled from 'styled-components';
import { checkedMixin } from './CheckboxMixins';
import { ICheckboxProps } from '@fluentui/react';

const Input: any = styled.input`
  -webkit-appearance: inherit;
  padding: 7px !important;
  border-radius: 1px;
  display: inline-block;
  position: relative;
  box-shadow: none;
  outline: none !important;
  margin: ${(props: any) => (props.inGrid ? '8px 0 0 8px !important' : '2px 0 0 0 !important;')};
  height: 16px !important;
  width: 16px !important;

  &:active,
  &:focus {
    border: 1px solid ${(props: any) => props.theme.colors.inputBorderHover};
    box-shadow: none;
  }

  ${checkedMixin};
`;

type CheckboxPropTypes = ICheckboxProps & {
  id?: string;
  disabled?: boolean;
  'data-testid'?: string;
  testId?: string;
  value?: string;
  readOnly?: boolean;
  handleChange?: Function;
  setInputRef?: Function;
  onBlur?: Function;
  onFocus?: Function;
  tabIndex?: number;
  style?: any;
};

export const Checkbox = ({
  id = '',
  disabled = false,
  value,
  readOnly,
  setInputRef = () => {},
  handleChange = () => {},
  ...rest
}: CheckboxPropTypes) => {
  const disable = !!(readOnly || disabled);
  const node = useRef<HTMLInputElement | undefined>(undefined);

  const callbackRef: any = (instance: HTMLInputElement) => {
    node.current = instance;
    setInputRef(instance);
  };

  return (
    <Input
      autoComplete="off"
      data-testid={rest['data-testid'] || rest.testId}
      disabled={disable}
      key={id}
      ref={callbackRef}
      type="checkbox"
      value={value}
      {...rest}
    />
  );
};

export default Checkbox;
